import {css} from '@emotion/react'
import {InputText} from '@/components/Form'
import {useMapContext} from '@/components/MindMap/index.mjs'

const cssInput = css({
    display: 'flex',
    width: 'auto',
    borderRadius: 4,
})

export const InputReplace = ({textSearch, ...props}) => {
    const map = useMapContext()
    const permission = map.usePermission()

    if (! (
        textSearch &&
        permission.has('write')
    )) {
        return null
    }

    return (
        <InputText
            css={cssInput}
            allowClear
            placeholder="替换"
            {...props}
        />
    )
}

export const InputSearch = props => {
    return (
        <InputText
            css={cssInput}
            allowClear
            changeDelay={300}
            focus
            placeholder="搜索"
            {...props}
        />
    )
}
